import { render, staticRenderFns } from "./CalculoDialog.vue?vue&type=template&id=2542fdaa"
import script from "./CalculoDialog.vue?vue&type=script&lang=js"
export * from "./CalculoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports